export default "__VITE_ASSET__f706bc00__"